import { useMemo } from 'react';
import { SearchableSelect } from './searchable-select';
import { listTimeZoneOptions } from '@/lib/timezone';

/**
 * TimezoneSelect — a searchable IANA timezone picker (not a free-text field).
 *
 * Populated from the runtime's complete IANA tz database. Each option shows
 * "(GMT+05:30) India Standard Time" with the identifier ("Asia/Kolkata") on the second line,
 * and both are searchable. The value emitted is ALWAYS the canonical IANA identifier — never
 * the display label, an abbreviation, or a UTC offset. Offsets refresh per render (DST-aware).
 */
export function TimezoneSelect({
  value,
  onChange,
  disabled = false,
  placeholder = 'Select a timezone…',
}: {
  value: string;
  onChange: (tz: string) => void;
  disabled?: boolean;
  placeholder?: string;
}) {
  const options = useMemo(
    () => listTimeZoneOptions().map((o) => ({ value: o.value, label: o.label, sub: o.sub })),
    [],
  );
  return (
    <SearchableSelect
      value={value}
      onChange={onChange}
      options={options}
      disabled={disabled}
      placeholder={placeholder}
    />
  );
}
